import { VerticalContainer } from '@american-autonomy/ag-ui';

import Toggle from 'components/Toggle';
import CaptionText from 'components/text/CaptionText';

import useTranslation from './hooks/useTranslation';

import { TEST_ID, TOGGLE_TEST_ID } from './constants';
import type { AssetTypeCounts, AssetTypeLabels, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const AssetModelSelector: FunctionComponent<Props> = ({
    assetModels,
    className = '',
    onSelect,
    selectedAssetModelId,
    testId = TEST_ID
}) => {
    const { ASSET_MODEL_SELECTOR_LABEL, BATTERY, DRONE } = useTranslation();

    const assetTypeLabels: AssetTypeLabels = { BATTERY, DRONE };

    const modelsPerAssetType = assetModels.reduce<AssetTypeCounts>(
        (counts, { assetType }) => ({ ...counts, [assetType]: (counts[assetType] ?? 0) + 1 }),
        {}
    );

    const options = assetModels.map(({ assetType, id, name }) => {
        const isAssetTypeAmbiguous = (modelsPerAssetType[assetType] ?? 0) > 1;

        return {
            label: isAssetTypeAmbiguous ? name : (assetTypeLabels[assetType] ?? name),
            value: id
        };
    });

    const activeIndex = assetModels.findIndex(({ id }) => id === selectedAssetModelId);

    return (
        <VerticalContainer className={`${className} ${styles.assetModelSelector}`} testId={testId}>
            <CaptionText className={styles.label} text={ASSET_MODEL_SELECTOR_LABEL} />

            <Toggle
                activeIndex={activeIndex}
                onClick={onSelect}
                options={options}
                testId={TOGGLE_TEST_ID}
            />
        </VerticalContainer>
    );
};

export default AssetModelSelector;
